export default __webpack_public_path__ + "static/media/cpLaundryPassPinkEn.a0a4733d.jpg";